import { useEffect, useRef } from 'react';
import { useGlobalToastHandler } from 'views/mutual/globalToast/hooks';
import { useGetAddressInfoQuery } from 'views/utils/graphql/graphql';

export type AddressInfo = {
  prefecture?: string;
  cityCountry?: string;
  townStreetAddress?: string;
};

export const useAddressInput = (postCode: string | undefined, onSearchResult: (addressInfo: AddressInfo) => void) => {
  const { showError, messageClose } = useGlobalToastHandler();
  // 自分が検索を実行したかどうかを追跡するフラグ
  const isSearchingRef = useRef(false);

  const [addressInfo, executeSearch] = useGetAddressInfoQuery({
    variables: { postCode: postCode ?? '' },
    requestPolicy: 'network-only',
    pause: true,
  });
  const searchAddress = () => {
    // 検索を実行し、フラグを立てる
    isSearchingRef.current = true;
    executeSearch();
  };

  useEffect(() => {
    if (!addressInfo.data || addressInfo.fetching) return;
    // 自分が検索を実行していない場合は無視（他のコンポーネントからの更新）
    if (!isSearchingRef.current) return;
    // 検索を実行したのでフラグを解除
    isSearchingRef.current = false;

    if (addressInfo.data!.GetAddressInfo == null) {
      showError('有効な郵便番号を入力してください');
    } else {
      messageClose();
    }

    onSearchResult({
      prefecture: addressInfo.data!.GetAddressInfo?.Prefecture ?? '',
      cityCountry: addressInfo.data!.GetAddressInfo?.CityCountry ?? '',
      townStreetAddress: addressInfo.data!.GetAddressInfo?.TownStreetAddress ?? '',
    });
  }, [addressInfo]);

  return { searchAddress };
};
